import { TemplateSelection, TemplateSelectionProps } from "@kaltura/mediaspace-shared-ui";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { CustomIllustration, illustrationsMap } from "./illustrations";
import { ButtonAnalyticsProvider } from "@kaltura/mediaspace-shared-hooks";

// All props except "templates" are optional
export type LiveStudioTypeProps = Pick<TemplateSelectionProps, "templates"> &
    Partial<Omit<TemplateSelectionProps, "templates">>;

/**
 * Live Studio type selection form field.
 */
export const LiveStudioTypeSelection = (props: LiveStudioTypeProps) => {
    return (
        <ButtonAnalyticsProvider namePrefix={"Toggle Live studio template -"}>
            <TemplateSelection
                id={"roomMode"}
                labelSingle={translate("Session type")}
                labelMultiple={translate("Choose type")}
                illustrationsMap={illustrationsMap}
                defaultIllustration={CustomIllustration}
                {...props}
            />
        </ButtonAnalyticsProvider>
    );
};
